import { Input, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Request } from '../../models/Request/request.model';
import * as AppConst from '../../data/test.data';

export class RequestPropTab {
    @Input() requestCode: string;
    @Input() isView: boolean = true;
    @Input() requestID: number;
    @Input() request: Request;
    @Input() iPathCode: number;
    isInit: boolean = false;
    @ViewChild('ddlArea') ddlArea: any;
    @ViewChild('ddlRequestType') ddlRequestType: any;
    @ViewChild('ddlRequestTypeDetail') ddlRequestTypeDetail: any;
    @ViewChild('ddlSubdis') ddlSubdis: any;
    @ViewChild('ddlContractForm') ddlContractForm: any;
    @ViewChild('ddlStatus') ddlStatus: any;


    DateFormat = { type: 'dateTime', format: 'dd/MM/yyyy' };    

    get AppConst() { return AppConst; }

    constructor(protected cdr: ChangeDetectorRef) {
       
    }

    startInit() {
        if (!this.isInit) {
            this.isInit = true;
            this.init();
        }
    }

    init() {
    }

    ngRefresh() {
        this.cdr.detectChanges();
    }

    onDataBoundArea() {

        if (this.request != null) {

            this.ddlArea.value = this.request.Areaname;
        }
    }

    onDataBoundRequestType() {
        if (this.request != null) {
            console.log('ddlRequestType', this.request.Idloaiyeucau);
            this.ddlRequestType.value = this.request.Idloaiyeucau;
        }
    }

    onDataBoundRequestTypeDetail() {
        if (this.request != null) {
            console.log('RequestTypeDetailId', this.request.RequestTypeDetailId);
            this.ddlRequestTypeDetail.value = this.request.RequestTypeDetailId;
        }
    }

    onDataBoundSubdis() {
        if (this.request != null) {
            this.ddlSubdis.value = this.request.Subdistcode;
        }
    }

    onDataBoundContractForm() {
        if (this.request != null) {
            this.ddlContractForm.value = this.request.ContractFormId;
        }
    }

    onDataBoundStatus() {
        if (this.request != null) {
            this.ddlStatus.value = this.request.Idstatus;
        }
    }
}
